/**
 * Layout Component
 * A React component that serves as the main layout wrapper for the application
 * Manages theme switching and sidebar state while coordinating Navigation, Main content and Footer
 */

import React, { useContext, useState } from "react";
import Navigation from "./navigation";
import Main from "./main";
import { ThemeContext } from "../context/theme-context";
import Footer from "./footer";

/**
 * Main layout component that structures the application
 * Handles theme switching functionality and sidebar toggle state
 * @returns {JSX.Element} Rendered component with Navigation, Main content and Footer
 */
export default function Layout() {
  /**
   * Theme context values and updater function
   * Extracted from ThemeContext using useContext hook
   */
  const { theme, changeTheme } = useContext(ThemeContext);

  /**
   * Handles theme change events from theme selector
   * Updates the application theme based on user selection
   * @param {Event} event - The theme change event
   */
  const handleThemeChange = (event) => {
    changeTheme(event.target.value);
  };

  /**
   * Sidebar state management
   * Controls the open/closed state of the sidebar navigation
   */
  const [isOpen, setIsOpen] = useState(false);

  /**
   * Toggles the sidebar open/closed state
   * Inverts the current isOpen state when called
   */
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  /**
   * Component render section
   * Renders the main application layout with dynamic theme classes
   */
  return (
    <div className="cust-front">
      <Navigation
        changeTheme={handleThemeChange}
        theme={theme}
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
      />
      <Main isOpen={isOpen} toggleSidebar={toggleSidebar} />
      {/* <Footer /> */}
    </div>
  );
}
